import { Injectable, inject } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterSelectItem } from '../../../components/checkbox-facette/checkbox-liste/filterSelectItem';
import { AggregationKey } from '../../../model/aggregations';
import { Foerderart } from '../../../model/foerderart';
import { FacettenService } from '../facetten.service';
import { FoerderartUrlService } from './foerderarturl.service';

/**
 * Seit NOWSUCHE-1250 ist die Forderart Facette keine normale Facette mehr,
 * sondern Verhält sich eher wie die Anbieter-Facette, @see anbieter.service.ts.
 * Ferner ist für das UI die Unterscheidung zwischen Bundesweit und Bundeslang-Förderarten entfallen
 */
@Injectable({
  providedIn: 'root'
})
export class FoerderartService extends FacettenService {
  constructor() {
    const urlService = inject(FoerderartUrlService);

    super(urlService, AggregationKey.Foerderart, []);
  }

  public foerderart$: Observable<Foerderart[]> = combineLatest([
    this.filterAggregationsService.filterAggregations$,
    this.facettenUrlService.selectedOptionIds$
  ]).pipe(
    map(([{ FOERDERART }, selektierteFoerderarten]) =>
      Object.entries(FOERDERART).map(([id, option]) => ({
        id: option.id,
        name: option.name,
        ausgewaehlt: selektierteFoerderarten.includes(id),
        anzahl: option.anzahl
      }))
    )
  );

  public override getSelectItems$(): Observable<FilterSelectItem[]> {
    return combineLatest([
      this.filterAggregationsService.filterAggregations$,
      this.selectedIds$
    ]).pipe(
      // Zugriff über JS-Syntax auf FOERDERART-Feld der Aggregations,
      // welche aus dem Backend ans Frontend kommen.
      // die äußere ID wird dabei aktuell ignoriert und nur die innere verwendet
      map(([{ FOERDERART }, selektierteFoerderarten]) =>
        Object.values(FOERDERART).map((option) => ({
          key: option.id,
          ariaLabel: option.name,
          treffer: option.anzahl,
          label: option.name,
          selected: selektierteFoerderarten.includes(option.id),
          active: true
        }))
      )
    );
  }

  private readonly numberSelected: Observable<number> =
    this.facettenUrlService.selectedOptionIds$.pipe(map((optionIds) => optionIds.length));

  private readonly hasItems$: Observable<boolean> = this.foerderart$.pipe(
    map((option) => option?.length > 0)
  );

  // Setzt den expansion state der Facette
  public override setExpanded(expanded: boolean) {
    this._expanded$.next(expanded);
  }

  /**
   * Anzahl der ausgewählten, aktiven Optionen
   */
  public override getNumberSelected$(): Observable<number> {
    return this.numberSelected;
  }

  /**
   * Wahr gdw. aktiven Optionen vorhanden sind
   */
  public override getHasItems$(): Observable<boolean> {
    return this.hasItems$;
  }

  // Aktualisiert den ausgewählten Filter
  public override updateSelectedIds(selectedIds: string[]): void {
    this.facettenUrlService.updateSelection(selectedIds);
  }
}
